var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-8"},[(_vm.spots && _vm.spots.items)?_c('div',{staticClass:"row"},_vm._l((_vm.spots.items),function(spot,i){return _c('div',{key:i,staticClass:"col-md-6 col-lg-4 mb-6"},[_c('spot-item-list',{attrs:{"spot-item":spot}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }